var paginationThemeWeb = {
  color: 'primary',
  button: {
    borderRadius: 'borders.radius'
  },
  buttons: {
    inactiveBackground: 'text.primary'
  }
};
var paginationThemeNative = {
  color: 'primary'
};

export { paginationThemeNative, paginationThemeWeb };
